// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rzdXF","review":"styles_review__8JE4s","starsContainer":"styles_starsContainer___EOUd"};